// extracted by mini-css-extract-plugin
module.exports = {"startBtn":"GeneralBtn_startBtn__3LxSA"};